export const setTotalQuestions = (id: string, total: number) => {
  const element = document.getElementById(id);
  if (element) {
    element.textContent = total.toString();
  }
};

export const setCurrentQuestionIdx = (id: string, idx: number) => {
  const element = document.getElementById(id);
  if (element) {
    element.textContent = idx.toString();
  }
};

export const addBackListener = (
  id: string,
  currentIdx: number,
  setIdx: (idx: number) => void,
) => {
  const backBtn = document.getElementById(id);
  if (backBtn) {
    const onBack = (e: any) => {
      e.preventDefault();
      if (currentIdx > 0) {
        const newIdx = currentIdx - 1;
        setIdx(newIdx);
      } else {
        history.back();
      }
    };
    backBtn.addEventListener('click', onBack);
    return () => backBtn.removeEventListener('click', onBack);
  }
};

const getProgress = (current: number, total: number) => {
  if (total === 0) {
    return 0;
  }
  const result = (current / total) * 100;
  return Math.round(result);
};

export const updateProgress = (
  id: string,
  percentageId: string,
  total: number,
  current: number,
) => {
  const progressBar = document.getElementById(id);
  const percentageEl = document.getElementById(percentageId);
  const progress = current + 1 === total ? 100 : getProgress(current, total);

  if (progressBar) {
    progressBar.style.width = `${progress}%`;
  }
  if (percentageEl) {
    percentageEl.textContent = `${progress}%`;
  }
};
